import sha1 from "sha1";
import { isPasswordPwned } from "@/shared/api/userService";

export const isNotPwned = (password: string): Promise<boolean> => {
  const pwHash = sha1(password);

  return isPasswordPwned(pwHash)
    .then(_ => Promise.resolve(true))
    .catch(error => {
      if (error.response && error.response.status === 400) {
        return Promise.reject({
          message: "This password has been detected in a list of previously compromised passwords.  " +
            "Please choose another password."
        });
      }

      return Promise.reject({
        message: "An error occurred in vetting password strength.  Please retry submitting the password."
      });
    });
};